import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TableComponent } from '../../../utils/table/table.component';
import { TableColumnModel } from '../../../../models/table-column.model';
import { AResourceTableComponent } from '../../../AResourceTableComponent';
import { FormGroupHelper } from '../../../../helpers/form-group-helper';

import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';
import {EmployeeService} from "../../../../services/resources/employee.service";
import {EmployeeModel} from "../../../../models/resources/employee.model";

@Component({
  selector: 'app-employees-table',
  imports: [
    TableComponent,
    ReactiveFormsModule
  ],
  template: `<app-table
    [columns]="tableColumns"
    [data]="models()"
    [filterFormGroup]="filterFormGroup"
    [loading]="resourceService.loading()"
    (doFilterRequest)="resourceService.getAll($event)"
    (urlParamsChange)="this.urlParams = $event"
    [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
    [pagination]="resourceService.paginationMeta()"
    [deleteLoadingIds]="this.deleteLoadingIds()"
    />`,
  styles: ``,
})
export class EmployeesTableComponent extends AResourceTableComponent<EmployeeModel> {

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'vitabene_id',
      'first_name',
      'last_name',
      'abbreviation'
    ]
  );

  tableColumns: TableColumnModel[] = [
    {
      name: 'EMPLOYEES.VITABENE_ID',
      selector: [{ selector: 'vitabeneId' }],
      filterFormControl: this.filterFormGroup.get('vitabene_id'),
      filterFormControlLabel: 'EMPLOYEES.VITABENE_ID',
      filterUrlParam: 'vitabene_id',
    },
    {
      name: 'EMPLOYEES.FIRST_NAME',
      selector: [{ selector: 'firstName' }],
      filterFormControl: this.filterFormGroup.get('first_name'),
      filterFormControlLabel: 'EMPLOYEES.FIRST_NAME',
      filterUrlParam: 'first_name',
    },
    {
      name: 'EMPLOYEES.LAST_NAME',
      selector: [{ selector: 'lastName' }],
      filterFormControl: this.filterFormGroup.get('last_name'),
      filterFormControlLabel: 'EMPLOYEES.LAST_NAME',
      filterUrlParam: 'last_name',
    },
    {
      name: 'EMPLOYEES.ABBREVIATION',
      selector: [{ selector: 'abbreviation' }],
      filterFormControl: this.filterFormGroup.get('abbreviation'),
      filterFormControlLabel: 'EMPLOYEES.ABBREVIATION',
      filterUrlParam: 'abbreviation',
    },
    {
      name: 'EMPLOYEES.MEDICINE_PERSONAL',
      selector: [{ selector: 'isNurse' }],
      isCheckbox: true
    },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true,
          objectBaseLink: '/employees'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]

  constructor(
    formBuilder: FormBuilder,
    public employeeService: EmployeeService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      employeeService,
      httpErrorsService,
      notificationService,
      'EMPLOYEES');
  }
}
